<template>
  <div id="app">
    <Header v-if="this.$store.state.access_token"></Header>
    <div class="row" id="body-row">
      <Sidebar v-if="this.$store.state.access_token"></Sidebar>
      <router-view/>
    </div>
    <Footer v-if="this.$store.state.access_token"></Footer>

  </div>
</template>
 
<script>
    import Header from './Doc/Header'
    import Sidebar from './Doc/Sidebar'
    import Footer from './Doc/Footer'

    export default {
        created() {
            //console.log(this.$i18n.messages.tr)
            //localStorage.setItem("Mestav", 'test');
            this.$store.dispatch("initAuth");

        },
        components: {
            Header,
            Sidebar,
            Footer
        },
        data() {
            return {}
        },
        methods: {


        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue